export const MODULE_TYPE_ENUM = {
  advertisement: "advertisement",
  home: "home",
  priceList: "promo",
};
